import { ReactNode } from "react";

export const Wrapper = ({
  wrapper,
  children,
}: {
  wrapper: (children: ReactNode) => ReactNode;
  children: ReactNode;
}) => <>{wrapper(children)}</>;
